import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Index = makeShortcode("Index");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`These are the legal policies of npm, Inc.`}</p>
    {
      /* edit the output of Index in `src/nav-base.yml` */
    }
    <Index mdxType="Index" />
    <p>{`These are updated from time to time.  Their sources are stored in a git repository at `}<a parentName="p" {...{
        "href": "https://github.com/npm/documentation/tree/main/content/policies"
      }}>{`https://github.com/npm/documentation/tree/main/content/policies`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      